import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from '../widgets';
import { DataTableLoading, DataTableRecordsNotFound } from '../widgets/DataTable';
import FilterDropDown from './FilterDropDown';
import SeedRow from './SeedRow';
import { setEditedSeedHistory, setFilteredHistory, setSelectedIds } from '../../actions/plan';
import SeedBulkEdit from './SeedBulkEdit';
import { SubNav } from '../layout/submenu';

const SeedTable = ({ isRequesting: seedHistoryRequesting, data = {}, unknownColumns, isPlanterAllocation }) => {
	const dispatch = useDispatch();
	const { enableBulkEdit, selectedLoads, payload, data: filteredData } = useSelector(state => state.plan.seedHistory);
	const [selectAll, setSelectAll] = useState(false);

	const [sort, setSort] = useState({
		direction: 1,
		field: null
	});

	const filter = key => <FilterDropDown seedData={data} keyName={key} />

	useEffect(() => {
		const { body } = data['seedHistory'];
		if (selectedLoads && body && selectedLoads.length > 0 && selectedLoads.length === body.length) setSelectAll(true);
		else setSelectAll(false);
	}, [selectedLoads]);

	const handleSelectAll = checked => {
		const { body } = data['seedHistory'];
		if (!checked) {
			dispatch(setEditedSeedHistory({ updatedLoad: payload.history }));
			dispatch(setSelectedIds([]));
		}
		else {
			const selectedIds = body.map(e => e.load_activity_uuid);
			dispatch(setSelectedIds(selectedIds));
		}
		setSelectAll(checked);
	};

	const handleSort = (sortField, _body, key) => {
		if (!sortField) return;

		let sortedList = [];
		const { direction } = sort;
		let sortDirection = ((direction + 1) > 2) ? 0 : direction + 1;

		if (!direction) sortedList = filteredData && filteredData.history ? filteredData.history : [];

		sortedList = filteredData.history.sort((a, b) => {
			const x = String(a[sortField]).toLowerCase();
			const y = String(b[sortField]).toLowerCase();

			const desc = direction === 2 ? 1 : -1
			const asc = direction === 2 ? -1 : 1

			return (x > y) ? desc : ((y > x) ? asc : 0)
		});

		dispatch(setFilteredHistory(sortedList))
		setSort({ direction: sortDirection, field: key });
	};

	const renderSortOrder = sortField => {
		const { direction, field } = sort;

		if (sortField !== field || direction === 1) return <i className="fa fa-caret-down sort-direction hidden" aria-hidden="true" />;
		if (direction === 1) return <i className="fa fa-caret-down sort-direction hidden" aria-hidden="true" />;
		if (direction === 2) return <i className="fa fa-caret-down sort-direction px-2" aria-hidden="true" />;
		if (direction === 0) return <i className="fa fa-caret-up sort-direction px-2" aria-hidden="true" />;
	}

	return (<>
		{Object.keys(data).map((type, index) => {
			let { header, body } = data[type];
			header = header.filter((e) => !unknownColumns.includes(e.key))
			return type === 'seedHistory' && <div key={index}>
				<DataTable className="seedhistory_table">
					<DataTable.Header >
						<DataTable.Row>
							{enableBulkEdit &&
								<DataTable.Cell className={`seed_checkbox`}
									width="40px">
									<div
										style={{ overflow: 'hidden', paddingBottom: '16px' }}>
										<SubNav.Checkbox
											className="square"
											checked={selectAll}
											onChange={(e) => handleSelectAll(e.target.checked)}
										/>
									</div>
								</DataTable.Cell>}
							{header.filter(e => (e.isShow && (e.isShow !== undefined))).map((e, index) => (
								<DataTable.Cell
									key={index}
									width={e.width && e.width}
									id={e.key}
								>
									<div className='seed_table_header'>
										<span
											style={{ cursor: e.name ? 'pointer' : 'not-allowed' }}
											onClick={() => (e.isSort) && handleSort(e.name, body, e.key)}
										//onClick={() => handleSort(e.name, body, e.key)}
										>
											<span>{e.label}</span>
											<span>{renderSortOrder(e.key)}</span>
										</span>
										{e.isPipeFilter && filter(e.filter)}
									</div>
								</DataTable.Cell>
							))}
						</DataTable.Row>
					</DataTable.Header>

					<DataTable.Body>
						{enableBulkEdit && <SeedBulkEdit body={body} header={header} />}
						{!seedHistoryRequesting &&
							body.map((e, index) => <SeedRow
								data={e}
								unknownColumns={unknownColumns}
								index={index + 1}
								isRequesting={seedHistoryRequesting}
								key={index}
								isPlanterAllocation={isPlanterAllocation}
								header={header}
							/>)}
					</DataTable.Body>
				</DataTable>

				<div className='info-text'>
					{seedHistoryRequesting && <DataTableLoading />}
					{!seedHistoryRequesting && body && body.length === 0 && <DataTableRecordsNotFound />}
				</div>
			</div>;
		})}</>
	);
};

export default SeedTable;